import { useQuery } from '@tanstack/react-query';
import { CaretRight } from '@phosphor-icons/react';
import { Link } from 'react-router-dom';
import { PageHeader } from '../../components/PageHeader';
import { Spinner } from '../../components/ui';
import { useT } from '../../i18n';
import { api, type PromptSteps } from '../../lib/api';
import { errorText } from '../../lib/errors';

/** The brain steps, each with its working version and model (spec 7.4). */
export function AdminPromptsPage() {
  const t = useT();
  const { data, isLoading, error } = useQuery<PromptSteps>({
    queryKey: ['admin', 'prompts'],
    queryFn: () => api.adminListPrompts(),
  });

  return (
    <div className="min-h-screen p-4 max-w-lg mx-auto pb-12 safe-top safe-bottom">
      <PageHeader title={t.adminPrompts.title} to="/admin" />
      {isLoading && (
        <div className="flex justify-center py-6">
          <Spinner />
        </div>
      )}
      {error && <p className="text-sm text-hint">{errorText(error, t)}</p>}
      <ul className="space-y-2">
        {data?.steps.map((s) => (
          <li key={s.code}>
            <Link
              to={`/admin/prompts/${s.code}`}
              className="flex items-center gap-3 px-4 py-3 rounded-2xl bg-surface active:opacity-80"
            >
              <span className="flex-1 min-w-0">
                <span className="block text-sm font-semibold">{t.adminPrompts.steps[s.code]}</span>
                {s.active && (
                  <span className="block text-xs text-hint truncate">
                    {t.adminPrompts.version(s.active.version)} · {s.active.model}
                  </span>
                )}
              </span>
              <CaretRight size={16} className="text-hint flex-shrink-0" />
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}
